import { all, takeLatest, put, call, select } from "redux-saga/effects";
import { getToken, clearToken } from "../../helpers/utility";
import * as requests from "../../helpers/requests";
import config from "../../config";
import * as selectors from "./selectors";

import constants from "./constants";
import * as actions from "./actions";

import { deactivateExercise } from "../exercises/actions";

import * as athleteActions from "../athletes/actions";

import { watchLoadFullWorkout } from "../athletes/saga";

import { store } from "../store";
import _ from "lodash";

const uuid4 = require("uuid/v4");

const apiPUrl = `${config.api_url}/webapi/v1`;

const fetchProgramming = url => {
  return requests.get(url);
};

const deleteUrl = url => {
  return requests._delete(url);
};

export function* watchLoadStreams() {
  const requestPath = `/webapi/v1/stream/`;

  try {
    const response = yield call(fetchProgramming, config.api_url + requestPath);
    yield put(actions.fetchStreamsSuccess(response));

    return response;
  } catch (e) {
    return;
  }
}

export function* watchLoadPrograms(action) {
  let path = `/webapi/v1/partial_program/`;
  if (action.payload) {
    let user_id = action.payload;
    path = `/webapi/v1/partial_program_by_user_id/${user_id}`;
  }

  try {
    let response = yield call(fetchProgramming, config.api_url + path);

    yield put(actions.fetchProgramsSuccess(response));
    // console.log("response for programs", response);
    // response[0].day_uuid = response[0].days[0].uuid;
    // yield put(actions.fetchFullProgramSuccess(response[0]));
    return response;
  } catch (e) {
    console.log(e);
    return;
  }
}

function* deleteProgram(action) {
  const url = `${config.api_url}/webapi/v1/program/${action.payload.id}/`;
  const { programs } = store.getState().Programming;

  try {
    yield put(actions.deactivatePrograms());

    const response = yield call(deleteUrl, url);
    var new_programs = programs.filter(p => p.id !== action.payload.id);
    yield put(actions.fetchProgramsSuccess(new_programs));
    // yield call(watchLoadPrograms);
    yield put(actions.hideEditProgramModal());
  } catch (e) {
    console.log(e);
    return;
  }
}

function* activateProgram(action) {
  const requestPath = `/webapi/v1/program/`;

  const response = yield call(
    fetchProgramming,
    config.api_url +
      requestPath +
      (action.payload.id ? action.payload.id : action.payload.key) +
      "/"
  );

  yield put(actions.fetchFullProgramSuccess(response));
  // yield put({ type: constants.CLEAR_SELECTED_DAY });
  return response;
}

function* showEditProgramModal(action) {
  yield call(activateProgram, action);

  const { selected_program } = store.getState().Programming;

  if (selected_program.id === action.payload.id) {
    yield put({ type: constants.SHOW_EDIT_PROGRAM_MODAL_SUCESS });
    return;
  }

  const requestPath = `/webapi/v1/program/`;

  const response = yield call(
    fetchProgramming,
    config.api_url +
      requestPath +
      (action.payload.id ? action.payload.id : action.payload.key) +
      "/"
  );

  yield put.resolve({
    type: constants.FETCH_FULL_PROGRAM_SUCCESS,
    payload: { full_program: response },
    showingEditProgramModal: true
  });
  // yield put({ type: constants.SHOW_EDIT_PROGRAM_MODAL_SUCESS });
}

function* createProgram(action) {
  const url = `${apiPUrl}/program/`;
  const newProgram = {
    ...action.payload
  };
  const response = yield call(requests.post, url, JSON.stringify(newProgram));
  const {
    programs,
    selected_program,
    selectedDayId,
    selectedSeriesId
  } = store.getState().Programming;
  let new_program_obj = [...programs];
  new_program_obj.push(response);
  yield [
    // put(actions.createProgramSuccess(response)),
    // call(watchLoadPrograms),
    put(actions.fetchProgramsSuccess(new_program_obj)),
    put(actions.hideCreateProgramModal()),
    put(actions.hideEditProgramModal()),
    put(actions.activateProgram(response))
  ];
}

function* createSeriesPartial(series) {
  console.log("create series partial", JSON.stringify(series));
  const url = `${apiPUrl}/series/`;

  const response = yield call(requests.post, url, JSON.stringify(series));
  return response;
}

function* createSeries(action) {
  //it appears that we have to do a double patch here, once without the exercises, then once with
  let series = action.payload;
  const { selected_program } = store.getState().Programming;

  let new_selected_program = { ...selected_program };

  series = yield call(createSeriesPartial, series);

  let day = new_selected_program.days.find(d => d.id === series.program_day_id);
  day.entities = day.entities.filter(ns => ns.id !== series.id);
  day.entities.push(series);

  yield put({
    type: constants.FETCH_FULL_PROGRAM_SUCCESS,
    payload: { full_program: new_selected_program }
  });
  yield put(actions.hideCreateSeriesModal());
}

function* createDay(action) {
  const { selected_program } = store.getState().Programming;

  let day = action.payload;
  day.order = selected_program.days.length;

  var new_selected_program = { ...selected_program };

  const url = `${apiPUrl}/day/`;
  day = yield call(requests.post, url, JSON.stringify(day));

  new_selected_program.days.push(day);

  yield put({
    type: constants.PATCH_FULL_PROGRAM_SUCCESS,
    payload: new_selected_program
  });
  yield put(actions.hideCreateDayModal());
}

function* patchFullProgram(program) {
  const url = `${apiPUrl}/program/${program.id}/`;

  const response = yield call(requests.patch, url, JSON.stringify(program));

  // let j = yield call([response, "json"]);
  // console.log("response", j);

  yield [
    // put(actions.createProgramSuccess(response)),
    // put(actions.hideEditWorkoutModal()),
    put({ type: constants.PATCH_PROGRAM_SUCCESS, payload: response })
  ];
  return response;
}

function* patchProgram(program) {
  const url = `${apiPUrl}/partial_program/${program.id}/`;

  const response = yield call(requests.patch, url, JSON.stringify(program));

  // let j = yield call([response, "json"]);
  // console.log("response", j);

  // yield [
  //   put({ type: constants.PATCH_PROGRAM_SUCCESS, payload: response })
  // ];
  return response;
}

function* patchDay(day) {
  const { selected_program } = store.getState().Programming;

  const url = `${apiPUrl}/day/${day.id}/`;

  let new_selected_program = { ...selected_program };

  const response = yield call(requests.patch, url, JSON.stringify(day));

  new_selected_program.days = new_selected_program.days.filter(
    p => p.id !== response.id
  );
  new_selected_program.days.push(response);
  yield [
    put({
      type: constants.FETCH_FULL_PROGRAM_SUCCESS,
      payload: { full_program: new_selected_program }
    })
  ];
}

function* patchSeries(series) {
  console.log("patch series", series);
  const { selected_program } = store.getState().Programming;

  const url = `${apiPUrl}/series/${series.id}/`;

  let new_selected_program = { ...selected_program };

  const response = yield call(requests.patch, url, JSON.stringify(series));

  let day = new_selected_program.days.find(d => d.id === series.program_day_id);
  day.entities = day.entities.filter(ns => ns.id !== series.id);
  day.entities.push(series);

  console.log("about to fetch full program success");
  yield [
    put({
      type: constants.FETCH_FULL_PROGRAM_SUCCESS,
      payload: { full_program: new_selected_program }
    })
  ];

  // new_selected_program.days = new_selected_program.days.filter(
  //   p => p.id !== response.id
  // );
  // new_selected_program.days.push(response);
  // yield [
  //   put({
  //     type: constants.FETCH_FULL_PROGRAM_SUCCESS,
  //     payload: { full_program: new_selected_program }
  //   })
  // ];
}

function* patchStream(stream) {
  const url = `${apiPUrl}/stream/${stream.id}/`;

  const response = yield call(requests.patch, url, JSON.stringify(stream));
  console.log("response", response);
  yield [
    // put(actions.createProgramSuccess(response)),
    // put(actions.hideEditWorkoutModal()),
    put({ type: constants.PATCH_STREAM_SUCCESS, payload: response })
  ];
}

function* updateSeries(action) {
  const {
    selected_program,
    selectedDayId,
    selectedSeriesId
  } = store.getState().Programming;

  console.log("series from the modal", action.payload);

  var edited_series = action.payload;
  edited_series.exercises = edited_series.exercises.map((e, index) => ({
    ...e,
    order: index
  }));

  // //don't modify the state directly
  // var edited_program = _.cloneDeep(selected_program);
  // var day = edited_program.days.find(d => d.id === selectedDayId);

  // var series_index = day.entities.findIndex(e => e.id === selectedSeriesId);
  // day.entities[series_index] = edited_series;

  yield call(patchSeries, edited_series);
  yield put(actions.hideEditSeriesModal());
}

function* updateAddedExercise(action) {
  const {
    selected_program,
    selectedDayId,
    selectedSeriesId,
    selectedExerciseId,
    handle_change,
    selected_exercises
  } = store.getState().Programming;

  // console.log("exercise in updatedAddedExercise", action.payload);

  var edited_exercise = action.payload;
  var exercises = selected_exercises;

  let index = exercises.findIndex(e => e.exercise.id === edited_exercise.id);
  exercises[index].exercise = edited_exercise;

  // console.log(edited_exercise);
  // edited_series.exercises = edited_series.exercises.map((e, index) => ({
  //   ...e,
  //   order: index
  // }));

  //don't modify the state directly
  // var edited_program = _.cloneDeep(selected_program);
  // var day = edited_program.days.find(d => d.id === selectedDayId);

  // var series = day.entities.find(e => e.id === selectedSeriesId);

  // var exercise_index = series.exercises.findIndex(
  //   e => e.id === selectedExerciseId
  // );

  // series.exercises[exercise_index].exercise = {
  //   ...edited_exercise,
  //   id: uuid4(),
  //   edit_after_added: true
  // };

  // handle_change("exercises", series.exercises);
  handle_change("exercises", exercises);

  //we stripped out the exercises before, add them back in
  // edited_series.exercises = day.entities[series_index].exercises;
  // day.entities[series_index] = edited_series;

  // yield call(patchProgram, edited_program);
  yield put(actions.hideEditAddedExerciseModal());
  yield put(deactivateExercise());
}

function* updateDay(action) {
  console.log("in update day", action.payload);
  const {
    selected_program,
    selectedDayId,
    selectedSeriesId
  } = store.getState().Programming;

  var edited_day = action.payload;
  // console.log("edited day", edited_day);

  //don't modify the state directly
  var edited_program = _.cloneDeep(selected_program);
  var day_index = edited_program.days.findIndex(d => d.id === selectedDayId);
  edited_program.days[day_index] = edited_day;
  // day = edited_day;

  // console.log("program is", JSON.stringify(edited_program));
  console.log("data that we are patching the day with", edited_day);
  yield call(patchDay, edited_day);
  yield put(actions.hideEditDayModal());
}

function* updateSelectedProgram(action) {
  var edited_program = action.payload;
  yield call(patchFullProgram, edited_program);
}

function* updateProgram(action) {
  // console.log('here in update program')
  const { programs } = store.getState().Programming;

  var edited_program = action.payload;
  let response = yield call(patchProgram, edited_program);
  let new_programs = programs.filter(p => p.id !== response.id);
  new_programs.push(response);
  new_programs.sort((a, b) => (a.name < b.name ? -1 : 1));
  yield put(actions.fetchProgramsSuccess(new_programs));

  yield put(actions.hideEditProgramModal());
}

function* updateStream(action) {
  var edited_stream = action.payload;
  yield call(patchStream, edited_stream);
  yield call(watchLoadStreams);
  yield put(actions.hideEditStreamModal());
}

function* createStream(action) {
  // const {
  //   selected_program,
  //   selectedDayId,
  //   selectedSeriesId
  // } = store.getState().Programming;

  // var edited_program = _.cloneDeep(selected_program);
  var new_stream = action.payload;

  const url = `${config.api_url}/webapi/v1/stream/`;

  const response = yield call(requests.post, url, JSON.stringify(new_stream));
  // console.log("resonse from create series", response);
  yield [call(watchLoadStreams), put(actions.hideCreateStreamModal())];
  // yield put({ type: constants.PATCH_PROGRAM_SUCCESS, payload: response });
}

function* deleteDayFromProgram(action) {
  let day = action.payload;

  const { selected_program } = store.getState().Programming;
  let new_selected_program = { ...selected_program };
  let url = `${config.api_url}/webapi/v1/day/${day.id}/`;
  yield call(requests._delete, url);

  new_selected_program.days = new_selected_program.days.filter(
    d => d.id !== day.id
  );

  yield put({
    type: constants.FETCH_FULL_PROGRAM_SUCCESS,
    payload: { full_program: new_selected_program }
  });
  yield put(actions.hideEditDayModal());
}

function* deleteSeries(action) {
  let series = action.payload;

  const { selected_program } = store.getState().Programming;

  let new_selected_program = { ...selected_program };

  let day = new_selected_program.days.find(d => d.id === series.program_day_id);
  day.entities = day.entities.filter(ns => ns.id !== series.id);

  let url = `${config.api_url}/webapi/v1/series/${series.id}/`;
  const response = yield call(requests._delete, url);

  // yield call()
  // yield call(patchFullProgram, action.payload);
  // yield call(watchLoadPrograms);
  yield put(actions.hideEditSeriesModal());
  yield put(actions.fetchFullProgramSuccess(new_selected_program));
}

function* pasteDay(action) {
  let day = { ...action.payload };
  const { selected_program } = store.getState().Programming;
  console.log("day from pastday", day);

  //day uuid here is from the workout that an athlete logs
  if (day.uuid) {
    console.log("this must be where an existing day gets pasted");
    // alert("yeah");
    let newday = {
      day_name: 1,
      name: day.name,
      notes: "",
      entities: [],
      program_id: selected_program.id
    };
    // yield put(athleteActions.fetchFullWorkout(day.uuid));

    // let fullworkout = yield call(watchLoadFullWorkout, {
    //   workout_uuid: day.uuid
    // });
    // console.log("the full workout return from server is", fullworkout);

    let fullworkout = { ...selected_program };

    for (let i = 0; i < fullworkout.length; i++) {
      if (fullworkout[i].set_number === 1) {
        let ent = copy_series_from_log_to_programming(
          null,
          fullworkout[i],
          true
        );
        newday.entities.push(ent);
      }
    }

    // var edited_program = _.cloneDeep(selected_program);

    const url = `${config.api_url}/webapi/v1/day/`;
    let response = yield call(requests.post, url, JSON.stringify(newday));

    let orders = fullworkout.days.map(d => d.order);
    orders = Array.from(new Set(orders));
    if (orders.length === 1) {
    }

    console.log("ab÷out to call push on edited_program");

    fullworkout.days.push(response);
    yield put(actions.fetchFullProgramSuccess(fullworkout));
    // yield call(patchFullProgram, edited_program);

    return;
  }

  console.log("this must be where a new day gets created?", day);
  day.id = uuid4();
  day.program_id = selected_program.id;
  day.entities = day.entities.map(e => ({
    ...e,
    id: uuid4(),
    exercises: e.exercises.map(ex => ({ ...ex, id: uuid4() }))
  }));

  const url = `${config.api_url}/webapi/v1/day/`;
  let response = yield call(requests.post, url, JSON.stringify(day));

  let program = { ...selected_program };
  program.days.push(response);
  yield put(actions.fetchFullProgramSuccess(program));
  // yield call(patchFullProgram, program);
}

const copy_series_from_log_to_programming = (
  dayId,
  series,
  new_series = false
) => {
  let new_series_id = uuid4();

  let newseries = {
    // id: new_series_id,
    exercises: [],
    name: "",
    sets: "",
    identifier: series.identifier,
    notes: null,
    type: "2",
    coaches_note: "",
    coaches_name: "",
    program_day_id: dayId,
    child_id: null
  };
  if (new_series) {
    delete newseries.program_day_id;
  }

  let ex = series.exercise_logs.map((log, index) => ({
    id: uuid4(),
    exercise: {
      id: log.exercise_uuid,
      name: log.name,
      tracking_type: log.tracking_type,
      parent_id: null
    },
    // exercise_id: new_ex_id,
    weight: "",
    weight_bi_r: "",
    time: "",
    time_bi_r: "",
    reps: "",
    reps_bi_r: "",
    boolean_log: false,
    boolean_log_bi_r: false,
    coaches_note: "",
    distance_m: "",
    distance_km: "",
    elevation_m: "",
    text_field: "",
    tempo: "",
    order: log.order
    // program_series_id: new_series_id
  }));
  newseries.exercises = ex;
  return newseries;
};

function* pasteSeries(action) {
  //we know if came from the log if it's here
  var dayId = action.payload.dayId;
  var series = {};
  if (action.payload.series.fullworkout) {
    series = copy_series_from_log_to_programming(
      dayId,
      action.payload.series.series
    );

    // console.log("series", JSON.stringify(series));
  } else {
    console.log("pasting in the else from saga pasteseries");
    series = { ...action.payload.series };

    series.id = uuid4();
    series.program_day_id = dayId;
    series.exercises = series.exercises.map(ex => ({ ...ex, id: uuid4() }));
    //new need to add program_day_id to the series to realocate it correctly
    console.log("pasting in the else from saga pasteseries", series);
  }
  // console.log("series", JSON.stringify(series));
  series = yield call(createSeriesPartial, series);

  const { selected_program } = store.getState().Programming;
  let new_selected_program = { ...selected_program };

  let day = new_selected_program.days.find(d => d.id === series.program_day_id);
  day.entities = day.entities.filter(ns => ns.id !== series.id);
  day.entities.push(series);

  // console.log("here");

  // let day = selected_program.days.find(d => d.id === dayId);
  // day = { ...day };

  // console.log("here2");

  // day.entities.push(series);

  // let program = { ...selected_program };
  // let days = program.days.filter(d => d.id !== dayId);
  // days.push(day);

  // program.days = days;
  // console.log("final program", program);
  // console.log("final program", JSON.stringify(program));

  // yield call(createSeriesPartial, series);
  yield put(actions.fetchFullProgramSuccess(new_selected_program));
}

function* copyProgram(action) {
  let program = { ...action.payload };

  const requestPath = `/webapi/v1/program/`;

  let response = yield call(
    fetchProgramming,
    `${config.api_url}/webapi/v1/program/${program.id}/`
  );

  program = response;
  program.name = "Copy of " + program.name;
  program.id = uuid4();

  program.days = program.days.map(day => {
    let entities = day.entities.map(e => ({
      ...e,
      id: uuid4(),
      exercises: e.exercises.map(ex => ({ ...ex, id: uuid4() }))
    }));

    day.id = uuid4();
    day.entities = entities;
    return day;
  });

  yield call(createProgram, { payload: program });
}

function* filterProgramForAll(action) {
  let checked = action.payload;
  const { programs, backup_programs } = store.getState().Programming;
  let bf = [...backup_programs];
  let f = [...programs];

  if (checked) {
    f = [...backup_programs].filter(p => p.assign_to_all === true);
    f = programs.concat(f);
  } else {
    f = f.filter(c => c.assign_to_all === false);
  }
  // console.log("about to save out", typeof f, f);

  yield put({
    type: constants.SET_THIS_PAYLOAD,
    payload: { programs: f, switch_filter_assigned_to_all: !checked }
  });
}

function* filterProgramSpecificAthletes(action) {
  let checked = action.payload;
  const { programs, backup_programs } = store.getState().Programming;
  let bf = [...backup_programs];
  let f = [...programs];

  if (checked) {
    f = [...backup_programs].filter(p => p.assign_to_all === false);
    f = programs.concat(f);
  } else {
    f = f.filter(c => c.assign_to_all === true);
  }
  // console.log("about to save out", typeof f, f);

  yield put({
    type: constants.SET_THIS_PAYLOAD,
    payload: { programs: f, switch_filter_athlete_specific: !checked }
  });
}

export default function* programmingSagaWatcher() {
  yield all([
    takeLatest(constants.FETCH_STREAMS, watchLoadStreams),
    takeLatest(constants.FETCH_PROGRAMS, watchLoadPrograms),
    takeLatest(constants.CREATE_PROGRAM, createProgram),
    // takeLatest(constants.ADD_NEW_DAY, addNewDay),
    takeLatest(constants.CREATE_SERIES, createSeries),
    takeLatest(constants.UPDATE_SERIES, updateSeries),
    takeLatest(constants.UPDATE_SELECTED_PROGRAM, updateSelectedProgram),
    takeLatest(constants.UPDATE_PROGRAM, updateProgram),
    takeLatest(constants.UPDATE_DAY, updateDay),
    takeLatest(constants.CREATE_DAY, createDay),
    takeLatest(constants.DELETE_PROGRAM, deleteProgram),
    takeLatest(constants.UPDATE_STREAM, updateStream),
    takeLatest(constants.CREATE_STREAM, createStream),
    takeLatest(constants.DELETE_DAY_FROM_PROGRAM, deleteDayFromProgram),
    takeLatest(constants.DELETE_SERIES, deleteSeries),
    takeLatest(constants.PASTE_DAY, pasteDay),
    takeLatest(constants.PASTE_SERIES, pasteSeries),
    takeLatest(constants.UPDATE_ADDED_EXERCISE, updateAddedExercise),
    takeLatest(constants.CLIPBOARD_PROGRAM, copyProgram),
    takeLatest(constants.ACTIVATE_PROGRAM, activateProgram),
    takeLatest(constants.SHOW_EDIT_PROGRAM_MODAL, showEditProgramModal),
    takeLatest(constants.FILTER_PROGRAM_FOR_ALL, filterProgramForAll),
    takeLatest(
      constants.FILTER_PROGRAM_SPECIFIC_ATHLETES,
      filterProgramSpecificAthletes
    )
  ]);
}
